import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LocationDropdown from '../components/LocationDropdown';
import TimeSlotBubbles from '../components/TimeSlotBubbles';
import { combineDateAndTime, formatDate } from '../utils/dateHelpers';
import { getLocationById } from '../utils/locations';
import './BookingSelectionPage.css';

function BookingSelectionPage() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const bookingId = searchParams.get('bookingId');

    const [selectedLocationId, setSelectedLocationId] = useState('');
    const [error, setError] = useState('');

    // M1: Update page title
    useEffect(() => {
        document.title = 'Select Appointment — The IMA Group';
    }, []);

    const handleSlotSelection = (date, time, providerId, providerEmail, watsSlotId, slotStart, slotEnd) => {
        if (!selectedLocationId) {
            setError('Please select a location first');
            return;
        }

        // Combine date and time into ISO datetime
        const appointmentDatetime = combineDateAndTime(date, time);

        const reschedule = searchParams.get('reschedule') === 'true';
        const rescheduleQuery = reschedule ? '&reschedule=true' : '';

        let url = `/book/details?bookingId=${bookingId}&location=${encodeURIComponent(selectedLocationId)}&datetime=${encodeURIComponent(appointmentDatetime)}&date=${formatDate(date)}&time=${time}`;

        if (providerId) url += `&providerId=${encodeURIComponent(providerId)}`;
        if (providerEmail) url += `&providerEmail=${encodeURIComponent(providerEmail)}`;
        if (watsSlotId) url += `&watsSlotId=${encodeURIComponent(watsSlotId)}`;
        if (slotStart) url += `&slotStart=${encodeURIComponent(slotStart)}`;
        if (slotEnd) url += `&slotEnd=${encodeURIComponent(slotEnd)}`;

        url += rescheduleQuery;

        // Navigate to contact info page with selected details
        navigate(url);
    };

    const selectedLocation = getLocationById(selectedLocationId);

    return (
        <div className="booking-selection-page">
            <div className="page-header">
                <h1>Book Your Appointment</h1>
                <p>Select a location and time that works best for you</p>
            </div>

            {error && (
                <div className="error-banner" role="alert">
                    {error}
                </div>
            )}

            <LocationDropdown
                value={selectedLocationId}
                onChange={setSelectedLocationId}
            />

            {selectedLocation && (
                <div className="location-address-display" style={{
                    margin: '10px 0 20px',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    borderRadius: '8px',
                    borderLeft: '4px solid #0056b3'
                }}>
                    <h3 style={{ margin: '0 0 5px', fontSize: '1.1rem', color: '#333' }}>{selectedLocation.name}</h3>
                    <p style={{ margin: 0, color: '#666' }}>
                        {selectedLocation.address.line1}<br />
                        {selectedLocation.address.line2 && <>{selectedLocation.address.line2}<br /></>}
                        {selectedLocation.address.city}, {selectedLocation.address.state} {selectedLocation.address.zip}
                        <br />
                        <span style={{ fontSize: '0.9em', marginTop: '5px', display: 'inline-block' }}>
                            Tel: {selectedLocation.phone}
                        </span>
                    </p>
                </div>
            )}

            {selectedLocationId && selectedLocation && (
                <TimeSlotBubbles
                    location={selectedLocation.name}
                    onSelectSlot={handleSlotSelection}
                />
            )}

            {!selectedLocationId && (
                <div className="instruction-message">
                    <p>Please select a location to view available appointment times.</p>
                </div>
            )}
        </div>
    );
}

export default BookingSelectionPage;
